<div class='FollowUp'>
  <div class='d-flex flex-row justify-content-between'>
    <div class='Breadcrumbs mb-5'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/messages']">
          <mat-icon class='Breadcrumbs-icon back'>keyboard_backspace</mat-icon>
        </a>
        <a
          [routerLink]="['/messages']"
          class='Breadcrumbs-item first'
        >Inbox</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>Follow Up</span>
      </div>
    </div>
    <app-button
      *ngIf='showExportButton'
      [Click]='exportButtonProperties.onClick'
      [color]='exportButtonProperties.color'
      [size]='exportButtonProperties.size'
      [observeApi]="true"
      [text]='exportButtonProperties.text'></app-button>
  </div>
  <app-table
    (data)='onData($event)'
    *ngIf='tableReady'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFilterGroups'
    [rowClass]='rowClass'
    [selectable]='false'
    [useRouteNavigation]='false'></app-table>
</div>
